// ImageResize.js
import { blobToUniqueFile } from "../../utils/blobToUniqueFileUtils";
// or wherever you define a short random name

export async function scaleImageToFixedSize(file, width, height) {
  if (!file) return null;

  // 1) Convert to data URL
  const dataURL = await readFileAsDataURL(file);

  // 2) Load into an <img>
  const image = await loadImage(dataURL);

  // 3) Draw to an off-screen canvas of size width × height
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  // 4) Force the entire image to fill this area
  // If you want to preserve aspect ratio, you'd do different logic here
  ctx.drawImage(image, 0, 0, width, height);

  // 5) Convert the canvas to a blob
  const blob = await new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), "image/png");
  });
  if (!blob) return null;

  // 6) Convert to a short random-named File
  return blobToUniqueFile(blob, "png");
}

function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}
